import HelloHealthLogo from '../../images/helloHealthlogo.png'

export default {
  primaryColor: '#F5733B',
  linearBarColor: '#F5733B',
  // linearBg: '#EAF9F9',
  linearBg : 'linear-gradient(0deg, rgba(217, 217, 217, 0.25) 0%, rgba(217, 217, 217, 0.25) 100%), rgba(217, 217, 217, 0.25)',
  logo: HelloHealthLogo,
  showBottomLogo: true,
  inputFieldCSS : {
    inputfiledTextColor : "#000000",
    inputfiledBgColor : "#F5F5F5",
    inputfiledBorderRadious : "10px",
    inpurFieldBorderColor : "transparent",

    //focus state css 
    inputFieldBorderOnFocus : "2px solid #F5F5F5", 
    inpurFieldBorderColorOnFocus  : "transparent",
    inputfiledBgColorOnFocus : "#F5F5F5",

    //hover state
    inpuFieldBorderColorOhHover : "transparent",

    inputFieldPlaceholderColor : "rgba(0, 0, 0, 0.20)",
    inputFieldAnswerPillsBGColor : "#EBEBEB",
    inputFieldAnswerPillsTextColor : "#000",
    inpuFieldSuggestedListHoverOnOptionBgColor :  "#808080",
    inpuFieldSuggestedListOptionTextColor :  "#000",
    inpuFieldSuggestedListHoverOnOptionTextColor : "white",
    inpuFieldAddBtnTextColor : "#000",
    removeIconColor : "#000"
  },
  //select option box button
  optionsButtonCSS : {
    buttonTextColor : "black",
    buttonBgColor : "rgba(26, 26, 26, 0.08)",
    buttonTextColorOnHOver : "#fff",
    buttonBgColorOnHOver : "#F5733B",
  },
  orgId : 3,
  from_ClientName : "from_hellohealth"
  }

